import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgArrowHide24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor",
  "aria-label": "Arrow Hide"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3 17.75a.75.75 0 0 0 1.5 0v-12a.75.75 0 0 0-1.5 0zm3.11-5.727a.72.72 0 0 1 0-.547.4.4 0 0 1 .039-.065l.026-.04.021-.038a.4.4 0 0 1 .052-.08l4.869-5.261a.76.76 0 0 1 1.06-.05c.306.274.329.74.05 1.041l-3.728 4.03H20.25c.414 0 .75.33.75.737a.744.744 0 0 1-.75.737H8.5l3.728 4.03a.73.73 0 0 1-.05 1.041.76.76 0 0 1-1.06-.05l-4.87-5.264a.4.4 0 0 1-.052-.08l-.02-.037-.024-.035a.4.4 0 0 1-.042-.069",
  clipRule: "evenodd"
}));

export { SvgArrowHide24 as default };
//# sourceMappingURL=ArrowHide24.js.map
